module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Medium-Alphabetic.1d14d922.woff";